/**
 * 驼峰转下划线
 * @param str
 * @returns {string}
 */
export default function humpToUnderline(str: string): string {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}
